import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP, LegalLastUpdated } from './LegalPages';

export function CookiePolicyPage() {
  const { t } = useTranslation();
  return (
    <LegalShell titleKey="cookies.title">
      <LegalLead>{t('cookies.lead')}</LegalLead>

      <LegalH2>{t('cookies.necessary_title')}</LegalH2>
      <LegalP>{t('cookies.necessary_body')}</LegalP>

      <LegalH2>{t('cookies.functional_title')}</LegalH2>
      <LegalP>{t('cookies.functional_body')}</LegalP>

      <LegalH2>{t('cookies.analytics_title')}</LegalH2>
      <LegalP>{t('cookies.analytics_body')}</LegalP>

      <LegalH2>{t('cookies.marketing_title')}</LegalH2>
      <LegalP>{t('cookies.marketing_body')}</LegalP>

      <LegalH2>{t('cookies.control_title')}</LegalH2>
      <LegalP>
        {t('cookies.control_body_prefix')}{' '}
        <Link to="/privacy" className="text-accent-700 hover:text-accent-600 underline underline-offset-2">
          {t('cookies.control_body_link')}
        </Link>
        {t('cookies.control_body_suffix')}
      </LegalP>

      <LegalLastUpdated>{t('cookies.last_updated')}</LegalLastUpdated>
    </LegalShell>
  );
}
